import gaService from "@/api/services/ga.service";
import { Button, Dialog, DialogContent, TextField } from "@mui/material";
import React, { useState } from "react";
import ClearIcon from '@mui/icons-material/Clear';
import SharePopOver from "./SharePopOver";
import { getCookie } from "cookies-next";
import { v4 as uuidv4 } from "uuid";
import DataCard from "./dataCard";
import { useSnackbar } from "notistack";
import feedbackService from "@/api/services/feedback.service";
import useDevice from "@/hooks/useDevice";

const FeedbackSmileys = () => {
  const smileys = ["terrible", "bad", "okay", "good", "amazing"];
  const names = ["Terrible", "Bad", "Okay", "Good", "Amazing"];
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [modalToBeOpen, setModalToBeOpen] = useState(0);
  const [selectedSmiley, setSelectedSmiley] = useState<number | null>(null);

  const submitSmileyFeedback = (index : number) =>{
    gaService.ratings(index + 1);
                  if (index > 2) {
                    setModalToBeOpen(0);
                  } else {
                    setModalToBeOpen(1);
                  }
                  setSelectedSmiley(index + 1);
                  setDialogIsOpen(true);
                  feedbackService
                    .submitSmileys({
                      type: "RATING",
                      nps_score: index + 1,
                      uuid : getCookie("_trends")? getCookie("_trends") : uuidv4(),
                    })
                    .then((res) => {
                      if (res.success) {
                        if (index > 2) {
                          setModalToBeOpen(0);
                        } else {
                          setModalToBeOpen(1);
                        }
                        setSelectedSmiley(index + 1);
                        setDialogIsOpen(true);
                      }
                    });
                  localStorage.setItem(
                    "ratings",
                    JSON.stringify({
                      rating: index + 1,
                      created_on: new Date(),
                    })
                  );
  }
  return (
    <>
      <div className="flex justify-center gap-2 flex-col no-print">
        <h3 className="text-center text-lg mb-3 font-medium text-gray-100">
          Share how you feel about us
        </h3>
        <div className="flex justify-center gap-2">
          {smileys.map((reaction, index) => {
            return (
              <div
                className={`border-2 flex flex-col justify-center items-center lg:w-24 md:w-22 sm:w-20 xs:w-14 border-[rgba(255,255,255,0.7)] text-[#ffffff] font-medium rounded-md p-1 cursor-pointer smiley-hover ${
                  selectedSmiley === index + 1 ? "smiley-selected" : ""
                }`}
                onClick={() => {
                  // if (selectedSmiley === index + 1) return;
                  submitSmileyFeedback(index);
                }}
                key={index}
              >
                <div className="flex justify-center items-center lg:w-16 lg:h-16 md:w-16 md:h-16 sm:w-14 sm:h-14 xs:w-12 xs:h-12">
                  <img
                    src={
                      "https://sr-cdn-1.shiprocket.in/sr-promise/images/" +
                      reaction +
                      ".svg"
                    }
                    className="w-full h-full object-contain"
                    alt={names[index]}
                    draggable={false}
                  />
                </div>
                <p className="text-center  text-[10px]">{names[index]}</p>
              </div>
            );
          })}
        </div>
      </div>

      <Dialog
        open={dialogIsOpen}
        onClose={() => {
          setDialogIsOpen(false);
        }}
        sx={{
            "& .MuiPaper-root": {
                borderRadius:"16px",
                boxShadow: "none",
            }
        }}
      >
        {modalToBeOpen === 0 ? (
          <ThanksModal
            onClose={() => {
              setDialogIsOpen(false);
            }}
          />
        ) : (
          <FeedbackInput
            onClose={() => {
              setDialogIsOpen(false);
            }}
          />
        )}
      </Dialog>
    </>
  );
};

export default FeedbackSmileys;

const FeedbackInput = (props: { onClose: () => void }) => {
  const isMobile = useDevice()
  const reason = [
    "Improve Data readability",
    "Data inadequate",
    "Not useful insights",
    "Need additional data",
    "Difficult to use",
  ];
  const [selectedReasons, setSelectedReasons] = useState<string[]>([]);
  const [message, setMessage] = useState("");

  const { enqueueSnackbar } = useSnackbar();


  const submitFeedback = ()=>{
    if (message && message.length < 10) {
      enqueueSnackbar("Message should be atleast 10 characters long.", {variant : "error"});
      return;
    }
    if(!message || selectedReasons.length < 1 ){
      enqueueSnackbar("Please select any suggestion and add your feedback", {variant : "error"});
      return;
    }
      feedbackService
        .submitFeedback({
          type: "FEEDBACK",
          suggestions:
            selectedReasons.length > 0 ? selectedReasons : undefined,
          message: message ? message : undefined,
          uuid : getCookie("_trends") ? getCookie("_trends") : uuidv4() ,
        })
        .then((res) => {
          if (res.success) {
            enqueueSnackbar(
              "Thanks for the Feedback. It helps us improve."
            );
            props.onClose();
          }
          else{

          }
        });
  }
  return (
    <>
    <DataCard>
      <DialogContent
        sx={{
          paddingTop: "10px",
          padding: isMobile ? "10px" : "30px",
          maxHeight: "400px",
          overflowY: "auto",
        }}
      >
        <div className="flex justify-between mb-5">
          <h1>How can we make trend better</h1>
          <ClearIcon
            onClick={() => {
              props.onClose();
            }}
            className="cursor-pointer"
          />
        </div>

        <div>
          {reason.map((currReason) => {
            return (
              <span
                className={`border-2 p-2 m-1 inline-block rounded-md text-sm cursor-pointer font-medium
                    ${
                      selectedReasons.includes(currReason)
                        ? "border-green-300 bg-green-100 text-black"
                        : ""
                    }`}
                onClick={() => {
                  if (selectedReasons.includes(currReason)) {
                    setSelectedReasons(
                      selectedReasons.filter((reason) => reason !== currReason)
                    );
                  } else {
                    gaService.feedback_suggestions(currReason);
                    setSelectedReasons([...selectedReasons, currReason]);
                  }
                }}
                key={currReason}
              >
                {currReason}
              </span>
            );
          })}
        </div>

        <TextField
          id="outlined-basic"
          label="Comment (Required)"
          variant="outlined"
          sx={{
            width: "100%",
            marginTop: "20px",
            marginBottom: "20px",
          }}
          value={message}
          onChange={(e) => {
            setMessage(e.target.value);
          }}
          onBlur={(e) => {
            gaService.feedback_input(e.target.value);
          }}
        />

        <Button
          sx={{
            backgroundColor: "#6540F7",
            color: "white",
            width: "100%",
            marginTop: "10px",
            "&:hover": {
              backgroundColor: "#6540F7",
              color: "white",
            },
          }}
          onClick={() => submitFeedback()}
        >
          Submit
        </Button>
      </DialogContent>
      </DataCard>
    </>
  );
};

const ThanksModal = (props: { onClose: () => void }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const popOverIsOpen = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    gaService.shareNow();
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
    <DataCard minHeight={"auto"}>
      <DialogContent
        sx={{
          paddingTop: "10px",
          padding: "30px",
        }}
      >
        <div className="flex flex-col gap-4">
          <h1 className=" text-xl font-semibold text-white text-center">
            Your feedback means a lot to us!
          </h1>


          <p className="text-center">
            Your feedback is the secret sauce that flavors our improvement
            recipe! We can&apos;t wait to roll out the red carpet and host you
            for another spectacular experience. Your return visit will be the
            sequel to an already incredible story!
          </p>
          <SharePopOver
            isOpen={popOverIsOpen}
            anchorEl={anchorEl}
            onClose={() => handleClose()}
          />
          <Button
            sx={{
              backgroundColor: "#6540F7",
              color: "white",
              width: "100%",
              marginTop: "10px",
              "&:hover": {
                backgroundColor: "#6540F7",
                color: "white",
              },
            }}
            onClick={(e) => {
              handleClick(e);
            }}
          >
            Share with others
          </Button>
          <Button
            sx={{
              backgroundColor: "#white",
              color: "#6540F7",
              width: "100%",
              marginTop: "10px",
              border: "1px solid #6540F7",
              "&:hover": {
                backgroundColor: "#6540F7",
                color: "white",
              },
            }}
            onClick={() => {
              props.onClose();
            }}
          >
            Close
          </Button>
        </div>
      </DialogContent>
    </DataCard>

    </>
  );
};